// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G-Yv","col":"styles_col__174C8"};